
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[practiceId]",
      function () {
        return require("private-next-pages/[practiceId]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[practiceId]"])
      });
    }
  